[
  {
    "id": "cap-1-bosque-otonal",
    "name": "Bosque Otoñal",
    "biome": "bosque",
    "waves": [
      { "enemies": [{ "type": "slime", "count": 3, "hpMul": 1, "atkMul": 1 }] },
      {
        "enemies": [
          { "type": "slime", "count": 2, "hpMul": 1.1, "atkMul": 1 },
          { "type": "goblin", "count": 2, "hpMul": 1, "atkMul": 1 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 3, "hpMul": 1.1, "atkMul": 1 },
          { "type": "bat", "count": 2, "hpMul": 1, "atkMul": 1 }
        ]
      },
      {
        "enemies": [
          { "type": "slime", "count": 4, "hpMul": 1.2, "atkMul": 1.1 },
          { "type": "bat", "count": 2, "hpMul": 1.1, "atkMul": 1 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 3, "hpMul": 1.3, "atkMul": 1.1 },
          { "type": "bat", "count": 3, "hpMul": 1.2, "atkMul": 1.1 }
        ]
      },
      {
        "enemies": [
          { "type": "slime", "count": 3, "hpMul": 1.3, "atkMul": 1.2 },
          { "type": "goblin", "count": 3, "hpMul": 1.3, "atkMul": 1.2 }
        ]
      },
      {
        "enemies": [{ "type": "boss-bosque", "count": 1, "hpMul": 3, "atkMul": 1.1 }],
        "isBoss": true
      }
    ],
    "boardTable": [
      "board-bosque-1",
      "board-bosque-2",
      "board-bosque-3",
      "board-bosque-1",
      "board-bosque-2",
      "board-bosque-3",
      "board-bosque-2"
    ],
    "rewards": { "coins": 300, "xp": 120, "gearDrops": 1 }
  },
  {
    "id": "cap-2-lejano-oeste",
    "name": "Lejano Oeste",
    "biome": "desierto",
    "waves": [
      { "enemies": [{ "type": "goblin", "count": 4, "hpMul": 1.4, "atkMul": 1.2 }] },
      {
        "enemies": [
          { "type": "slime", "count": 3, "hpMul": 1.5, "atkMul": 1.2 },
          { "type": "bat", "count": 3, "hpMul": 1.4, "atkMul": 1.2 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 4, "hpMul": 1.6, "atkMul": 1.3 },
          { "type": "bat", "count": 2, "hpMul": 1.5, "atkMul": 1.2 }
        ]
      },
      {
        "enemies": [
          { "type": "slime", "count": 4, "hpMul": 1.7, "atkMul": 1.3 },
          { "type": "goblin", "count": 3, "hpMul": 1.7, "atkMul": 1.3 }
        ]
      },
      {
        "enemies": [
          { "type": "bat", "count": 4, "hpMul": 1.6, "atkMul": 1.4 },
          { "type": "goblin", "count": 3, "hpMul": 1.8, "atkMul": 1.4 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 4, "hpMul": 1.9, "atkMul": 1.4 },
          { "type": "slime", "count": 3, "hpMul": 2, "atkMul": 1.4 }
        ]
      },
      {
        "enemies": [
          { "type": "bat", "count": 5, "hpMul": 1.8, "atkMul": 1.5 },
          { "type": "goblin", "count": 3, "hpMul": 2, "atkMul": 1.5 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 4, "hpMul": 2.1, "atkMul": 1.5 },
          { "type": "slime", "count": 4, "hpMul": 2.2, "atkMul": 1.5 }
        ]
      },
      {
        "enemies": [
          { "type": "boss-oeste", "count": 1, "hpMul": 4.5, "atkMul": 1.5 },
          { "type": "goblin", "count": 2, "hpMul": 1.6, "atkMul": 1.4 }
        ],
        "isBoss": true
      }
    ],
    "boardTable": [
      "board-oeste-1",
      "board-oeste-2",
      "board-oeste-3",
      "board-oeste-1",
      "board-oeste-2",
      "board-oeste-3",
      "board-oeste-1",
      "board-oeste-2",
      "board-oeste-3"
    ],
    "rewards": { "coins": 550, "xp": 220, "gearDrops": 1 }
  },
  {
    "id": "cap-3-cripta",
    "name": "Cripta Sombría",
    "biome": "cripta",
    "waves": [
      { "enemies": [{ "type": "goblin", "count": 5, "hpMul": 2.2, "atkMul": 1.5 }] },
      {
        "enemies": [
          { "type": "spider", "count": 4, "hpMul": 2.2, "atkMul": 1.5 },
          { "type": "slime", "count": 3, "hpMul": 2.4, "atkMul": 1.5 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 4, "hpMul": 2.5, "atkMul": 1.6 },
          { "type": "bat", "count": 3, "hpMul": 2.4, "atkMul": 1.6 }
        ]
      },
      {
        "enemies": [
          { "type": "slime", "count": 5, "hpMul": 2.6, "atkMul": 1.6 },
          { "type": "goblin", "count": 3, "hpMul": 2.7, "atkMul": 1.6 }
        ]
      },
      {
        "enemies": [
          { "type": "spider", "count": 5, "hpMul": 2.6, "atkMul": 1.7 },
          { "type": "goblin", "count": 4, "hpMul": 2.8, "atkMul": 1.7 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 5, "hpMul": 2.9, "atkMul": 1.7 },
          { "type": "slime", "count": 4, "hpMul": 3, "atkMul": 1.7 }
        ]
      },
      {
        "enemies": [
          { "type": "bat", "count": 6, "hpMul": 2.8, "atkMul": 1.8 },
          { "type": "goblin", "count": 4, "hpMul": 3, "atkMul": 1.8 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 5, "hpMul": 3.1, "atkMul": 1.8 },
          { "type": "slime", "count": 4, "hpMul": 3.3, "atkMul": 1.8 }
        ]
      },
      {
        "enemies": [
          { "type": "spider", "count": 6, "hpMul": 3, "atkMul": 1.9 },
          { "type": "goblin", "count": 5, "hpMul": 3.3, "atkMul": 1.9 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 5, "hpMul": 3.4, "atkMul": 1.9 },
          { "type": "slime", "count": 5, "hpMul": 3.5, "atkMul": 1.9 }
        ]
      },
      {
        "enemies": [
          { "type": "bat", "count": 6, "hpMul": 3.3, "atkMul": 2 },
          { "type": "goblin", "count": 5, "hpMul": 3.5, "atkMul": 2 }
        ]
      },
      {
        "enemies": [
          { "type": "boss-cripta", "count": 1, "hpMul": 6, "atkMul": 1.8 },
          { "type": "bat", "count": 3, "hpMul": 2.6, "atkMul": 1.7 }
        ],
        "isBoss": true
      }
    ],
    "boardTable": [
      "board-cripta-1",
      "board-cripta-2",
      "board-cripta-3",
      "board-cripta-1",
      "board-cripta-2",
      "board-cripta-3",
      "board-cripta-1",
      "board-cripta-2",
      "board-cripta-3",
      "board-cripta-1",
      "board-cripta-2",
      "board-cripta-3"
    ],
    "rewards": { "coins": 900, "xp": 380, "gearDrops": 2 }
  },
  {
    "id": "cap-4-volcan",
    "name": "Volcán Ardiente",
    "biome": "volcan",
    "waves": [
      { "enemies": [{ "type": "goblin", "count": 5, "hpMul": 3.4, "atkMul": 1.9 }] },
      {
        "enemies": [
          { "type": "spider", "count": 5, "hpMul": 3.4, "atkMul": 1.9 },
          { "type": "goblin", "count": 4, "hpMul": 3.6, "atkMul": 1.9 }
        ]
      },
      {
        "enemies": [
          { "type": "slime", "count": 5, "hpMul": 3.7, "atkMul": 2 },
          { "type": "goblin", "count": 4, "hpMul": 3.8, "atkMul": 2 }
        ]
      },
      {
        "enemies": [
          { "type": "bat", "count": 6, "hpMul": 3.7, "atkMul": 2 },
          { "type": "goblin", "count": 5, "hpMul": 4, "atkMul": 2 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 6, "hpMul": 4, "atkMul": 2.1 },
          { "type": "slime", "count": 4, "hpMul": 4.2, "atkMul": 2.1 }
        ]
      },
      {
        "enemies": [
          { "type": "spider", "count": 6, "hpMul": 4, "atkMul": 2.1 },
          { "type": "goblin", "count": 5, "hpMul": 4.3, "atkMul": 2.1 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 6, "hpMul": 4.3, "atkMul": 2.2 },
          { "type": "slime", "count": 5, "hpMul": 4.5, "atkMul": 2.2 }
        ]
      },
      {
        "enemies": [
          { "type": "bat", "count": 7, "hpMul": 4.2, "atkMul": 2.2 },
          { "type": "goblin", "count": 5, "hpMul": 4.6, "atkMul": 2.2 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 6, "hpMul": 4.6, "atkMul": 2.3 },
          { "type": "slime", "count": 5, "hpMul": 4.8, "atkMul": 2.3 }
        ]
      },
      {
        "enemies": [
          { "type": "spider", "count": 7, "hpMul": 4.5, "atkMul": 2.3 },
          { "type": "goblin", "count": 6, "hpMul": 4.8, "atkMul": 2.3 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 7, "hpMul": 4.9, "atkMul": 2.4 },
          { "type": "slime", "count": 5, "hpMul": 5, "atkMul": 2.4 }
        ]
      },
      {
        "enemies": [
          { "type": "bat", "count": 8, "hpMul": 4.7, "atkMul": 2.4 },
          { "type": "goblin", "count": 6, "hpMul": 5, "atkMul": 2.4 }
        ]
      },
      {
        "enemies": [
          { "type": "goblin", "count": 7, "hpMul": 5, "atkMul": 2.5 },
          { "type": "slime", "count": 6, "hpMul": 5.2, "atkMul": 2.5 }
        ]
      },
      {
        "enemies": [
          { "type": "spider", "count": 8, "hpMul": 5, "atkMul": 2.5 },
          { "type": "goblin", "count": 7, "hpMul": 5.3, "atkMul": 2.5 }
        ]
      },
      {
        "enemies": [
          { "type": "boss-volcan", "count": 1, "hpMul": 9, "atkMul": 2.5 },
          { "type": "goblin", "count": 4, "hpMul": 4, "atkMul": 2.2 },
          { "type": "bat", "count": 3, "hpMul": 3.8, "atkMul": 2.2 }
        ],
        "isBoss": true
      }
    ],
    "boardTable": [
      "board-volcan-1",
      "board-volcan-2",
      "board-volcan-3",
      "board-volcan-1",
      "board-volcan-2",
      "board-volcan-3",
      "board-volcan-1",
      "board-volcan-2",
      "board-volcan-3",
      "board-volcan-1",
      "board-volcan-2",
      "board-volcan-3",
      "board-volcan-1",
      "board-volcan-2",
      "board-volcan-3"
    ],
    "rewards": { "coins": 1400, "xp": 600, "gearDrops": 2 }
  }
]
